export const LENS_BETA_HOST = 'beta.amd-tracer.alexa.amazon.dev';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

export function isLensEnabledHost(hostname = window.location.hostname) {
  return hostname === LENS_BETA_HOST || LOCAL_HOSTS.has(hostname);
}
